import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import { AddNewRuleComponent } from './add-new-rule.component';

@NgModule({
  declarations: [AddNewRuleComponent],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
  ],
})
export class AddNewRuleModule {
}